import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { sendErrorEvent } from '@trello/error-reporting';
import { WorkspacesAutoNameAlert } from 'app/src/components/WorkspacesAutoNameAlert';
import { renderComponent } from 'app/src/components/ComponentWrapper';

export const unmountWorkspacesAutoNameAlert = function () {
  if (this.workspacesAutoNameAlertTarget) {
    ReactDOM.unmountComponentAtNode(this.workspacesAutoNameAlertTarget);
    this.workspacesAutoNameAlertTarget = null;
  }
};

export const renderWorkspacesAutoNameAlert = function () {
  if (!this.workspacesAutoNameAlertTarget) {
    this.workspacesAutoNameAlertTarget = this.el.querySelector(
      '#workspaces-auto-name-alert',
    );

    if (this.workspacesAutoNameAlertTarget) {
      try {
        renderComponent(
          <WorkspacesAutoNameAlert orgId={this.model.get('idOrganization')} />,
          this.workspacesAutoNameAlertTarget,
        );
      } catch (err) {
        sendErrorEvent(err, {
          tags: {
            ownershipArea: 'trello-mocha',
            feature: 'Workspaces Auto Name Alert',
          },
          extraData: {
            component: 'board-view-collaboration',
          },
        });
      }
    }
  }
};
